module.exports = {
  install(Vue) {
    Vue.prototype.shuffleCard = {
      init(cnt) {
        let shapes = ['heart', 'spade', 'clover', 'diamond'];
        const cards = [];
        const result = [];
        for (let i = 0; i < 4; i += 1) {
          cards[shapes[i]] = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'K', 'J', 'Q', 'A'];
        }
        for (let j = 0; j < cnt; j += 1) {
          const shape = shapes[Math.floor(Math.random() * shapes.length)];
          const cardIndex = Math.floor(Math.random() * cards[shape].length);
          const card = (cards[shape][cardIndex]).toUpperCase();
          cards[shape].splice(cardIndex, 1);
          result.push({ shape, card });
          shapes = shapes.filter(name => cards[name].length > 0);
        }
        return result;
      },
      grouping(units, cards) {
        const result = [];
        const groupCount = Math.ceil(cards.length / units);
        for (let i = 0; i < groupCount; i += 1) {
          const data = [];
          for (let j = i * units; j < (i * units) + units; j += 1) {
            if (cards[j]) {
              data.push(cards[j]);
            } else {
              break;
            }
          }
          result.push(data);
        }
        return result;
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/plugins/shuffle_card.js